$.fn.addCopyMark = function(src){
    var re = new RegExp("("+src+")","ig");
    this.each(function(){
        $(this).contents().filter(function(){
            return this.nodeType != 1;
        }).each(function(){
            var output = $(this).text().replace(re,"<sup>&reg;</sup>");
            if (output != $(this).text()) {
                $(this).wrap("<p />").parent().html(output).contents().unwrap();
            }
        });
    });
};
$.fn.addTmMark = function(src){
    var re = new RegExp("("+src+")","ig");
    this.each(function(){
        $(this).contents().filter(function(){
            return this.nodeType != 1;
        }).each(function(){
            var output = $(this).text().replace(re,"<sup>™</sup>");
            if (output != $(this).text()) {
                $(this).wrap("<p />").parent().html(output).contents().unwrap();
            }
        });
    });
};
jQuery(document).ready(function(){
  setTimeout(function() {
  	$(".product-single__title,.product-single__title a,div.featured-row__subtext p,.product-recommendations__inner li .product-card__title").addCopyMark("®");
  	$(".product-single__title,.product-single__title a,div.featured-row__subtext p,.product-recommendations__inner li .product-card__title").addTmMark("™");
  }, 1000);
    /*if(jQuery('.template-product .product-single__title').length > 0){
      jQuery(".template-product .product-single__title").html(
        jQuery(".template-product .product-single__title").html().replace("®", "<sup>&reg;</sup>").replace("™", "<sup>™</sup>")
      );
  	}
  	setTimeout(function() {
  	if(jQuery('.product-recommendations__inner li .product-card__title').length > 0){
      jQuery(".product-recommendations__inner li .product-card__title").html(
        jQuery('.product-recommendations__inner li .product-card__title').html().replace("®", "<sup>&reg;</sup>").replace("™", "<sup>™</sup>")
      );
  	}
    }, 1000);
  	if(jQuery('#tab-1 .product-single__title').length > 0){
      jQuery("#tab-1 .product-single__title").html(
        jQuery("#tab-1 .product-single__title").html().replace("®", "<sup>&reg;</sup>").replace("™", "<sup>™</sup>")
      );
  	}
    if(jQuery('#tab-2 .product-single__title').length > 0){
      jQuery("#tab-2 .product-single__title").html(
        jQuery("#tab-2 .product-single__title").html().replace("®", "<sup>&reg;</sup>").replace("™", "<sup>™</sup>")
      );
  	}
  	if(jQuery('#tab-3 .product-single__title').length > 0){
      jQuery("#tab-3 .product-single__title").html(
        jQuery("#tab-3 .product-single__title").html().replace("®", "<sup>&reg;</sup>").replace("™", "<sup>™</sup>")
      );
  	}
    if(jQuery('div.featured-row__subtext').length > 0){
      jQuery("div.featured-row__subtext").html(
        jQuery("div.featured-row__subtext").html().replace("®", "<sup>&reg;</sup>").replace("™", "<sup>™</sup>")
      );
    }*/
jQuery(".tabs-menu li a").click(function(event) {
event.preventDefault();
jQuery(this).parent().addClass("current");
jQuery(this).parent().siblings().removeClass("current");
var tab = jQuery(this).attr("href");
jQuery(".tab-content").not(tab).css("display", "none");
jQuery(tab).fadeIn();
});
jQuery('.qtybox .btnqty').on('click', function(){
var qty = parseInt(jQuery(this).parent('.qtybox').find('.quantity-input').val());
if(jQuery(this).hasClass('qtyplus')) {
qty++;
}else {
if(qty > 1) {
qty--;
}
}
qty = (isNaN(qty))?1:qty;
jQuery(this).parent('.qtybox').find('.quantity-input').val(qty);
});
jQuery('.accordions-item h4').click(function() {
jQuery(this).toggleClass('active').parent('.accordions-item').siblings().children('h4').removeClass('active');
jQuery(this).next('.accordions-content').slideToggle().parent('.accordions-item').siblings().children('.accordions-content').slideUp();
});
  
jQuery('.accordions-container').each(function(){
  jQuery(this).find('.accordions-content').hide();
  jQuery(".accordions-heading:first").addClass('active'); 
  jQuery(".accordions-heading:first").next().show();
  jQuery(this).find('.accordions-heading').click(function() {  
	jQuery(this).toggleClass('active').parent('.accordions-item').siblings().children('.accordions-heading').removeClass('active');
	jQuery(this).next('.accordions-content').slideToggle().parent('.accordions-item').siblings().children('.accordions-content').slideUp();
  });  
});

jQuery('.faq-section').each(function(){
jQuery(this).find('.faq-section-item .faq-section-item-title').click(function() {
jQuery(this).toggleClass('active').parent('.faq-section-item').siblings().children('.faq-section-item-title').removeClass('active');
jQuery(this).next('.faq-section-item-text').slideToggle().parent('.faq-section-item').siblings().children('.faq-section-item-text').slideUp();
jQuery(this).parent('.faq-section-item').toggleClass('active').siblings().removeClass('active');
});
});


/*var showChar = 255;
var ellipsestext ="...";
var moretext ="Read more";
var lesstext ="Read less";


jQuery('.more').each(function() {
var content = jQuery(this).html();

if(content.length > showChar) {

var c = content.substr(0, showChar);
var h = content.substr(showChar, content.length - showChar);

var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

jQuery(this).html(html);
}

});

jQuery(".morelink").click(function(){
if(jQuery(this).hasClass("less")) {
jQuery(this).removeClass("less");
jQuery(this).html(moretext);
} else {
jQuery(this).addClass("less");
jQuery(this).html(lesstext);
}
jQuery(this).parents('.more').find('.moreellipses').toggle();
jQuery(this).parents('.more').find('.morecontent span').toggle();
return false;
});*/


function AddReadMore() {
//This limit you can set after how much characters you want to show Read More.
var carLmt = 253;
// Text to show when text is collapsed
var readMoreTxt = " Read more";
// Text to show when text is expanded
var readLessTxt = "Read less";


//Traverse all selectors with this class and manupulate HTML part to show Read More
jQuery(".addReadMore").each(function() {
if (jQuery(this).find(".firstSec").length)
return;

var allstr = jQuery(this).html();
if (allstr.length > carLmt) {
var firstSet = allstr.substring(0, carLmt);
var secdHalf = allstr.substring(carLmt, allstr.length);
var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'><span>" + readMoreTxt + "</span></span><span class='readLess'><span>" + readLessTxt + "</span></span>";
jQuery(this).html(strtoadd);
}

});
//Read More and Read Less Click Event binding
jQuery(document).on("click", ".readMore span,.readLess span", function() {
jQuery(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
});
}
jQuery(function() {
//Calling function after Page Load
//AddReadMore();
});


moonscroll();
imageAnimation()
// window.onbeforeunload = function () {
// window.scrollTo(0,0);
// };


if(navigator.userAgent.match(/Trident.*rv:11\./)) {
jQuery('.default-page table').each(function(){
jQuery(this).wrap('<div class="scrollable-wrapper"></div>');
});
}

if(navigator.appVersion.indexOf("MSIE")!=-1){
jQuery('.default-page table').each(function(){
jQuery(this).wrap('<div class="scrollable-wrapper"></div>');
});
}

});

jQuery(window).load(function(){
  var topheight = jQuery('.site-header').outerHeight();
var hash_value = window.location.hash;
jQuery('a[href*=\\#]').on('click', function(e){
  jQuery('.mobile-nav-wrapper').removeClass('js-menu--is-open is-transitioning'); 
   jQuery('.js-mobile-nav-toggle').addClass('mobile-nav--open').removeClass('mobile-nav--close'); 
//e.preventDefault();
if (window.location.hash) {
 
var hash = window.location.hash;
if (jQuery(hash).length) {
jQuery('html, body').animate({
scrollTop : jQuery(hash).offset().top -topheight
}, 800);
}
} else {
//e.preventDefault();
  if(jQuery(this).hasClass("noscrolleff")){
	console.log('return');
  } else {
    jQuery('html, body').animate({
    scrollTop : jQuery(this.hash).offset().top -topheight
    }, 800);
  }
}
return false;
});

if (jQuery(hash_value).length > 0) {
var getH = jQuery(hash_value);
jQuery('html, body').animate( {scrollTop: getH.offset().top}, 800);
}

// window.onbeforeunload = function () {
// window.scrollTo(0,0);
// };
var scrollnow = function(e) {
// if scrollnow()-function was triggered by an event
var topheight = jQuery('.site-header').outerHeight();
if (e) {
e.preventDefault();
var target = this.hash;
}
// else it was called when page with a #hash was loaded
else {
var target = location.hash;
}
  if(jQuery(this).hasClass("noscrolleff")){
	console.log('return');
  } else {
    // same page scroll
    jQuery('html, body').animate({
    scrollTop : jQuery(target).offset().top - topheight
    }, 700);
  }
};

// if page has a #hash
if (location.hash) {
jQuery('html, body').scrollTop(0).show();
// smooth-scroll to hash
scrollnow();
}

// for each <a>-element that contains a "/" and a "#"
jQuery('a[href*="/"][href*="#"]').each(function(){
// if the pathname of the href references the same page
if (this.pathname.replace(/^\//,'') == location.pathname.replace(/^\//,'') && this.hostname == location.hostname) {
// only keep the hash, i.e. do not keep the pathname
jQuery(this).attr("href", this.hash);
}
});

// select all href-elements that start with #
// including the ones that were stripped by their pathname just above
jQuery('a[href^="#"]:not([href="#"])').click(scrollnow);


moonscroll();
imageAnimation();
jQuery('.clickabletag').click(function(){
  var url = jQuery(this).attr("href");
  window.location = url;
    return true;
});
jQuery('.noscrolleff').click(function(){
	
    return false;
});
  
});

function moonscroll(){
var topheight = jQuery('.site-header').outerHeight() + 100;
if(jQuery('.moon-section').length > 0){
var moontop = jQuery('.moon-section').offset().top;
var moontopins = jQuery('#inspiration').offset().top - topheight;
var winH = jQuery(window).height() / 2;
var getMoon = moontop - winH;
jQuery(window).scroll(function(){

var scroll = jQuery(window).scrollTop();

if(scroll >= moontopins) {
jQuery('.moon-section').removeClass('moon-animation');
}
});
}
}

function imageAnimation(){
  var topheight = jQuery('.site-header').outerHeight() + 100;
if(jQuery('.inspiration').length > 0){
var instop = jQuery('.inspiration-right').offset().top - topheight;
jQuery(window).scroll(function(){
var scroll = jQuery(window).scrollTop();
if(scroll >= instop) {
jQuery('.inspiration').removeClass('image-animation');
}
});
}
  
if(jQuery('.sustaibility-image-text').length > 0){
  const offsettop = jQuery('.sustainblity-section').offset().top - topheight;
  jQuery(window).scroll(function(){
    const scroll = jQuery(window).scrollTop();
    if(scroll >= offsettop) {
    	jQuery('.sustainblity-section').addClass('animated');
    }
  });
}
  
}